import configData from '../../config.json';
import httpClient from './httpClient';

const SUBSCRIPTION_KEY_PARAM = 'subscription-key';
const ROLEX_BRAND = 'ROLEX';
const SERVICE_CARD_TYPE = 'ServiceCard';

export function fetchWatchData(token, options = {}) {
  return httpClient.get('/WatchData/', {
    token,
    query: {
      [SUBSCRIPTION_KEY_PARAM]: configData.subscriptionkey,
    },
    responseType: 'json',
    signal: options.signal,
  });
}

export function generateAssociationCode(token, options = {}) {
  return httpClient.get('/GenerateCode/', {
    token,
    query: {
      [SUBSCRIPTION_KEY_PARAM]: configData.subscriptionkey,
    },
    headers: {
      'X-Brand': ROLEX_BRAND,
      'X-CardType': SERVICE_CARD_TYPE,
    },
    responseType: 'json',
    signal: options.signal,
  });
}
